
export default function TrustBadges() {
  const certifications = [
    {
      name: 'ISO 9001',
      description: 'إدارة الجودة',
      icon: 'ri-medal-line'
    },
    {
      name: 'HSE',
      description: 'الصحة والسلامة',
      icon: 'ri-shield-check-line'
    },
    {
      name: 'API',
      description: 'معايير البترول',
      icon: 'ri-oil-line'
    },
    {
      name: 'AML',
      description: 'مكافحة غسل الأموال',
      icon: 'ri-bank-line'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-[#595A5C] mb-4">الشهادات والمعايير</h2>
          <p className="text-lg text-gray-600">
            نلتزم بأعلى المعايير الدولية في جميع أعمالنا
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {certifications.map((cert, index) => (
            <div key={index} className="text-center group">
              <div className="w-20 h-20 mx-auto mb-4 bg-gray-50 rounded-full flex items-center justify-center group-hover:bg-[#E71B25] transition-colors duration-300">
                <i className={`${cert.icon} text-3xl text-[#595A5C] group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="font-bold text-[#595A5C] text-lg mb-2">{cert.name}</h3>
              <p className="text-gray-600 text-sm">{cert.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
